import VueI18n from 'vue-i18n'; // 注意Vue2.0要用8.x的版本，Vue3.0要用9.x以上的版本
import Vue from 'vue';

// 导入语言包
import CN from './lang/CN.json';

Vue.use(VueI18n);

// 定义支持的语言列表
export const LOCALES = ['CN'];

// 检查语言是否受支持
function isLocaleSupported(locale) {
  return LOCALES.includes(locale);
}

// 组合优先级逻辑
function getInitialLocale() {
  // 优先级1：从 localStorage 读取用户保存的语言
  const persisted = localStorage.getItem('locale');
  if (persisted) {
    return persisted;
  }
  // 优先级2：获取浏览器语言并匹配最接近的支持语言
  const browser = navigator.language;
  if (isLocaleSupported(browser)) {
    return browser;
  }
  const primaryLang = browser.split('-')[0];
  if (isLocaleSupported(primaryLang)) {
    return primaryLang;
  }
  return LOCALES[0]; // 默认语言
}

// 创建 i18n 实例
export const i18n = new VueI18n({
  globalInjection: true, // 全局注入，允许在模板中直接使用 $t
  locale: getInitialLocale(), // 设置初始语言
  missing: () => ' ', // 缺省值
  silentTranslationWarn: true,
  messages: {
    'CN': CN
  },
});

// 设置当前语言
export function setLocale(locale) {
  i18n.locale = locale;
  localStorage.setItem('locale', locale);
}

// 获取当前语言
export function getLocale() {
  return i18n.locale;
}

export default i18n;
